const MONTHS = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];

export function fmtINR(n) {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (isNaN(num)) return "—";
  return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function fmtLakh(n) {
  if (!n) return "₹0";
  if (n >= 100000) return "₹" + (n / 100000).toFixed(2) + " L";
  return fmtINR(n);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(String(iso).slice(0, 10) + "T00:00:00");
  if (isNaN(d)) return "—";
  return `${String(d.getDate()).padStart(2, "0")}-${MONTHS[d.getMonth()]}-${d.getFullYear()}`;
}

export function daysLabel(days) {
  if (days === null || days === undefined) return "—";
  if (days < 0) return `${days}d (overdue)`;
  if (days === 0) return "TODAY";
  if (days === 1) return "Tomorrow";
  return `in ${days}d`;
}

export const BUCKET_META = {
  overdue: { label: "Overdue", sub: "Critical", card: "bg-red-50 border-red-300", text: "text-red-700", num: "text-red-700", badge: "bg-red-600 text-white", ring: "ring-red-500" },
  today: { label: "Due today", sub: "Act now", card: "bg-rose-50 border-rose-300", text: "text-rose-700", num: "text-rose-700", badge: "bg-rose-600 text-white", ring: "ring-rose-500" },
  d1_3: { label: "1–3 days", sub: "Urgent", card: "bg-orange-50 border-orange-300", text: "text-orange-700", num: "text-orange-700", badge: "bg-orange-500 text-white", ring: "ring-orange-500" },
  d4_7: { label: "4–7 days", sub: "Upcoming", card: "bg-yellow-50 border-yellow-300", text: "text-yellow-800", num: "text-yellow-800", badge: "bg-yellow-500 text-white", ring: "ring-yellow-500" },
  d8_15: { label: "8–15 days", sub: "Scheduled", card: "bg-blue-50 border-blue-300", text: "text-blue-700", num: "text-blue-700", badge: "bg-blue-600 text-white", ring: "ring-blue-500" },
  d16_30: { label: "16–30 days", sub: "Safe", card: "bg-slate-50 border-slate-300", text: "text-slate-700", num: "text-slate-700", badge: "bg-slate-600 text-white", ring: "ring-slate-500" },
  later: { label: "Later (30+)", sub: "", card: "bg-slate-50 border-slate-200", text: "text-slate-600", num: "text-slate-600", badge: "bg-slate-200 text-slate-700", ring: "ring-slate-400" },
};

export function bucketBadge(bucket) {
  return BUCKET_META[bucket]?.badge || "bg-slate-200 text-slate-700";
}

// Clear, consistent bucket label used everywhere. Overdue shows the day count.
export function bucketLabel(bucket, days) {
  if (bucket === "overdue") {
    const n = Math.abs(days ?? 0);
    return `Overdue (${n} ${n === 1 ? "day" : "days"})`;
  }
  return BUCKET_META[bucket]?.label || "—";
}

export const STATUS_COLORS = {
  "Active": "bg-emerald-100 text-emerald-700",
  "Pending Activation": "bg-slate-100 text-slate-600",
  "Temporarily Suspended": "bg-amber-100 text-amber-700",
  "Customer Cancellation Requested": "bg-orange-100 text-orange-700",
  "Vendor Disconnection Pending": "bg-red-100 text-red-700",
  "Disconnected": "bg-slate-200 text-slate-500",
  "Closed": "bg-slate-200 text-slate-500",
};
